import { watchViewport, unwatchViewport } from 'tornis';
import { breakPoint } from './config';

// endpoint where day detail comes from
const otDetailUrl = window.openingTimesEndpoint;

// array of buttons
const buttons = [];
// the day detail expander
var dayDetail = null;

const homepageId = document.querySelector('.opening-times').getAttribute('data-homepage-id');

// Memory cache of previously fetched dates
const detailsCache = new Map();

// Get from the cache, or make a new fetch request
async function getOtDetail(date, id) {
    if (!detailsCache.has(date)) {
        let detailHtml = await (await window.fetch(otDetailUrl + '?date=' + date + '&homepageId=' + id)).text();
        detailsCache.set(date, detailHtml);
    }
    return detailsCache.get(date);
}

// watcher because we're doing some viewport gymnastics
var lastWidth = 0;
const watcher = ({ size }) => {
    if (size.changed) {
        if (dayDetail.expanded) {
            dayDetail.fitToContent();
        }
        // logical throttle, we only need to call again on a breakPoint change
        if ((lastWidth < breakPoint.MD && size.x >= breakPoint.MD)
            || (lastWidth >= breakPoint.MD && size.x < breakPoint.MD)) {
            dayDetail.updateOrder();
        }
        lastWidth = size.x;
    }
}

class DayDetail {

    constructor(el) {
        this.el = el;
        this.expanded = false;
        //this.wrapper = this.el.querySelector('.day-detail--wrapper');
        //this.inner = this.el.querySelector('.day-detail--content');
        //this.closeButton = this.el.querySelector('button.close');
    }

    show(button) {
        this.activeButton = button;
        this.updateOrder();
        getOtDetail(button.date, homepageId).then((content) => {
            this.inner.innerHTML = content;
            this.expand();
            // link click back to button
            this.closeButton.onclick = null;
            this.closeButton.onclick = () => {
                button.closeDetail();
                button.el.focus();
            }
        });
    }

    expand() {
        this.el.setAttribute('aria-expanded', true);
        this.el.ontransitionend = () => {
            // set focus on first link or button inside details element
            this.el.querySelector('a, button').focus();
            this.el.ontransitionend = null;
        }
        // animate in
        this.fitToContent();
        this.expanded = true;
    }

    hide(callback) {
        this.expanded = false;
        this.el.setAttribute('aria-expanded', false);
        this.activeButton = null;
        // animate out
        if (typeof callback === 'function') {
            this.el.ontransitionend = (event) => {
                // other animations might fire inside
                if (event.propertyName == 'max-height') {
                    callback();
                    this.el.ontransitionend = null;
                }
            };
        }
        this.el.style.maxHeight = 0;
    }

    fitToContent() {
        if (this.el.style.maxHeight != this.wrapper.offsetHeight + 'px') {
            this.el.style.maxHeight = this.wrapper.offsetHeight + 'px';
        }
    }

    updateOrder() {
        if (this.activeButton == null) {
            return;
        }
        let order = this.activeButton.order;
        if (window.innerWidth >= breakPoint.MD) {
            order = (Math.ceil(order / 7) * 7);
        }
        this.el.style.order = order;
    }
}

// the bit that we actually reuse most is the button, so that's what we code the interface around.
class OpeningTimesButton {

    constructor(el) {
        this.el = el;
        this.expanded = false;
        this.order = el.parentElement.style.order;
        //el.onclick = () => this.toggle();
        // buttons will need to keep track of each other
        buttons.push(this);
    }

    get date() {
        return this.el.dataset.date;
    }

    closeDetail(callback) {
        this.expanded = false;
        this.el.setAttribute('aria-expanded', false);
        dayDetail.hide(callback);
    }

    toggle() {
        if (this.expanded) {
            this.closeDetail();
        } else {
            this.expandDetail();
        }
    }

    expandDetail() {
        // get currently toggled button
        let currentlyExpanded = buttons.find(btn => btn.expanded);

        // if there's an open one, close it, then show this day's detail
        if (currentlyExpanded != null) {
            currentlyExpanded.closeDetail(() => dayDetail.show(this))
        } else {
            dayDetail.show(this);
        }

        this.expanded = true;
        this.el.setAttribute('aria-expanded', true);
    }
}

function init() {
    var wrapper = document.querySelector('.opening-times--month');
    dayDetail = new DayDetail(wrapper.querySelector('.day-detail'));
    wrapper.querySelectorAll('button[data-date]').forEach(
        button => {
            new OpeningTimesButton(button);
        }
    );
    watchViewport(watcher);
}

init();

// if we reload the month with ajax then we'll need to call init again.
export function reInit() {
    // remove the previous watcher
    unwatchViewport(watcher);
    // remove references to all existing buttons
    buttons.splice(0, buttons.length);
    // call init again
    init();
}
